import { Injectable } from '@angular/core';
import { Snackbar } from '@models/models';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    private snackbar: Snackbar;

    constructor() {}

    setSnackbar(snackbar: Snackbar): void {
        this.snackbar = snackbar;
    }

    public get snackbarItem(): Snackbar {
        return this.snackbar;
    }
}
